import React from 'react';
import { Box, Text, Flex, useToast } from '@chakra-ui/core';
import { Cell } from 'react-table';
import { useTranslation } from 'react-i18next';
import { FaRegCopy } from 'react-icons/fa';
import { CandidateSearchResponseType } from '../CandidateSearchTypes';

interface SeekerHireDetailIdCellProps {
  cell: Cell<CandidateSearchResponseType>;
}

export const SeekerHireDetailIdCell: React.FC<SeekerHireDetailIdCellProps> = ({ cell }) => {
  const { seekerHireDetailId } = cell.row.original;
  const toast = useToast();
  const { t } = useTranslation('candidateSearch');

  const onCopySeekerHireDetailId = async (hireDetailId: string) => {
    await navigator.clipboard.writeText(hireDetailId);
    toast({
      title: t('copiedHireId'),
      duration: 2000,
      isClosable: true,
    });
  };

  return (
    <>
      {seekerHireDetailId ? (
        <Flex d="inline-flex" justifyContent="flex-start" alignItems="center">
          <Box
            fontSize="14px"
            fontWeight={400}
            py="5px"
            mr={2}
            style={{
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              maxWidth: '200px',
            }}
          >
            {seekerHireDetailId}
          </Box>
          <Box>
            <FaRegCopy
              size={14}
              onClick={() => onCopySeekerHireDetailId(seekerHireDetailId)}
              data-testid={`copy-${seekerHireDetailId}`}
            />
          </Box>
        </Flex>
      ) : (
        <Text>-</Text>
      )}
    </>
  );
};
